import { fetch } from "./base";

export const getMusics = async (id, cache = false) => {
  return fetch("/musicurl/", { cache });
};

export const removeUserMusic = (id) => {
  return fetch("/useraudio/" + id, {
    headers: {
      method: "DELETE",
    },
  });
};
